<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.questions.edit") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <ValidationObserver v-slot="{ invalid }">
          <div class="row">
            <!-- bodyAr -->
            <ValidationProvider
              rules="required|arabicLettersAndNumbersOnly"
              :name="$t('SIDENAV.questions.bodyAr')"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('SIDENAV.questions.bodyAr')"
                v-model.trim="data.nameAr"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- bodyEn -->
            <ValidationProvider
              :name="$t('SIDENAV.questions.bodyEn')"
              rules="required|englishLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('SIDENAV.questions.bodyEn')"
                v-model.trim="data.nameEn"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- answerAr -->
            <ValidationProvider
              rules="required|arabicLettersAndNumbersOnly"
              :name="$t('SIDENAV.questions.answerAr')"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('SIDENAV.questions.answerAr')"
                v-model.trim="data.answerAr"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- answerEn -->
            <ValidationProvider
              rules="required|englishLettersAndNumbersOnly"
              :name="$t('SIDENAV.questions.answerEn')"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('SIDENAV.questions.answerEn')"
                v-model.trim="data.answerEn"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Status -->
            <ValidationProvider
              rules="required"
              :name="$t('PLACEHOLDERS.status')"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :optionsList="activeStatuses"
                :placeholder="$t('PLACEHOLDERS.status')"
                v-model="data.is_active"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Submit Button -->
            <div class="btn_wrapper">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
          </div>
        </ValidationObserver>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateAdditionalFields",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        nameAr: null,
        nameEn: null,
        answerEn: null,
        answerAr: null,
        is_active: null,
      },
      // End:: Data Collection To Send

      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: false,
        },
      ];
    },
  },

  methods: {
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },
    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
      this.data.answerAr = this.data.answerAr.replace(
        /[^\u0600-\u06FF\s]/g,
        ""
      );
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
      this.data.answerEn = this.data.answerEn.replace(this.EnRegex, "");
    },

    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `fqas/${this.$route.params.id}`,
        });

        this.data.nameAr = res.data.data.Fqa.trans?.question?.ar;
        this.data.nameEn = res.data.data.Fqa.trans?.question?.en;
        this.data.answerAr = res.data.data.Fqa.trans?.answer?.ar;
        this.data.answerEn = res.data.data.Fqa.trans?.answer?.en;
        this.data.is_active = res.data.data.Fqa.is_active;
        if (!this.data.is_active) {
          this.data.is_active = {
            id: 0,
            name: this.$t("STATUS.notActive"),
            value: 0,
          };
        } else {
          this.data.is_active = {
            id: 1,
            name: this.$t("STATUS.active"),
            value: 1,
          };
        }
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      if (
        !this.data.nameAr ||
        !this.data.nameEn ||
        !this.data.answerAr ||
        !this.data.answerEn ||
        !this.data.is_active
      ) {
        this.isWaitingRequest = false;
        if (!this.data.nameAr) {
          this.$message.error(this.$t("VALIDATION.questionAr"));
          return;
        }
        if (!this.data.nameEn) {
          this.$message.error(this.$t("VALIDATION.questionEn"));
          return;
        }
        if (!this.data.answerAr) {
          this.$message.error(this.$t("VALIDATION.answerAr"));
          return;
        }
        if (!this.data.answerEn) {
          this.$message.error(this.$t("VALIDATION.answerEn"));
          return;
        }
        if (!this.data.is_active) {
          this.$message.error(this.$t("VALIDATION.status"));
          return;
        }
      }
      this.submitForm();
      return;
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      // Start:: Build plain JSON payload
      const REQUEST_DATA = {
        question: {
          ar: this.data.nameAr || "",
          en: this.data.nameEn || "",
        },
        answer: {
          ar: this.data.answerAr || "",
          en: this.data.answerEn || "",
        },
        is_active: this.data.is_active?.value ? 1 : 0,
      };
      // End:: Build plain JSON payload

      try {
        await this.$axios({
          method: "PUT",
          url: `fqas/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/questions/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          error.response?.data?.message || "Something went wrong."
        );
      }
    },
    // End:: Submit Form
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}
</style>
